import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import CustomerOnboarding from "../pages/CustomerOnboarding";

export function getCustomerOnboardingMode(user) {
  if (!user) return null;
  if (user.role === "parent" && !user.parent_onboarding_completed) return "parent";
  if (user.role === "student" && !user.student_onboarding_completed) return "student";
  return null;
}

export function isCustomerOnboardingComplete(user) {
  return getCustomerOnboardingMode(user) === null;
}

const CUSTOMER_TUTORIAL_IDS = new Set(["parent-dashboard", "student-dashboard"]);

export function isCustomerTutorial(tutorialId) {
  return CUSTOMER_TUTORIAL_IDS.has(tutorialId);
}

export default function CustomerOnboardingGate({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const mode = !loading ? getCustomerOnboardingMode(user) : null;
  const readingLegalDocument = location.pathname.startsWith("/legal/");

  return (
    <>
      {children}
      {mode && !readingLegalDocument ? <CustomerOnboarding mode={mode} /> : null}
    </>
  );
}
